"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jul 12 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductSensitivityConverter.
 *
 * @author JMe
 */


var ProductSensitivityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSensitivityConverter, _DataObjectConverter_);

  function ProductSensitivityConverter() {
    _classCallCheck(this, ProductSensitivityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityConverter).apply(this, arguments));
  }

  return ProductSensitivityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSensitivityConverter = ProductSensitivityConverter;